jQuery(document).ready(function($) 
{
    $('.readmore-text').hide();
    $('.readmore-text').after('<a class="readMore" style="cursor:pointer;margin-bottom:12px;display:inline-block;">Read More</a>');
    $('.readMore').click(function()
    {
        $(this).prev().slideToggle(200,function() 
        {
            $(this).next('.readMore').text(function (index, text) 
            {
                return (text == 'Read More' ? 'Close' : 'Read More');
            });
        });
        return false;
    });

    // popup
   $('.popup-open').click(function(event) 
   {
        event.preventDefault();
        var $popup = $('.'+$(this).data('popup'));
        $popup.addClass('active');
        
        if ($(this).is('[data-video-src]')) {
            $popup.find('iframe').attr('src', $(this).data('video-src'));
        }
    });

    function close_popups() 
    {
		$('.popup.active').each(function() {
			$(this).removeClass('active');
          	$(this).find('iframe').attr('src', '');
		});
	}

    $('.popup, .popup-close').click(function(event) {
		event.preventDefault();
		close_popups();
	});

      //
    // Hype Group Scripts
    //
    
	$(".accord > h4.is-active")
    .next(".accord > h5")
    .slideDown();

    $(".accord > h5").slideUp();

    $(".accord > h4").click(function() 
    {
        // Cancel the siblings
        $('.accord > h5').next(".accordion-item")
        .removeClass("is-active")
        .slideUp();
        // Toggle the item
        $(this).toggleClass("is-active")
        .next(".accord > h5")
        .slideToggle("ease-out");
    });
});

   